import { Injectable } from "@angular/core";
import { ComponentStore, tapResponse } from '@ngrx/component-store';
import { FrequenciesMockStore } from "src/app/shared/store-mocks/frequencies.store";
import { MonthsMockStore } from "src/app/shared/store-mocks/months.store";



type State = {
    dateSelectorsVisibility: boolean
}

const initialState: State = {
    dateSelectorsVisibility: false
}

@Injectable()
export class CreateFormFrequencyMonthStore extends ComponentStore<State>{
    constructor(
        private monthsMockStore: MonthsMockStore,
    ){
        super({...initialState})
    }

    //selectors

    readonly entities$ = this.monthsMockStore.viewEntities$

    readonly dateSelectorsVisibility$ = this.select(state => state.dateSelectorsVisibility)

    readonly vm$ = this.select(
        this.entities$,
        this.dateSelectorsVisibility$,
        (entities, dateSelectorsVisibility) => {
            return {
               entities,
               dateSelectorsVisibility,
               value: ''
            }
        }, {debounce: true}
    )

    //updaters


    // effects

}
